import styled, { keyframes } from 'styled-components';

const Container = styled.div`
  color: white;
  background: #000000bf;
  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media screen and (orientation: portrait) {
    display: none;
  }
`;

const Text = styled.p`
  font-size: 30px;
  font-weight: bold;
  text-align: center;
`;

export const rotateAnimation = keyframes`
  0% {
      transform: rotate(0deg) scaleY(-1);
  }
  100% {
    transform: rotate(360deg) scaleY(-1);
  }
`;

const RotateIcon = styled((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 100 100" xmlSpace="preserve" {...props}>
    <path
      d="M36.6476746,87.6296921C21.3238163,82.4702377,10.755497,68.2587967,10.3472252,51.9320755  c-0.0136108-0.5442581-0.4478779-0.9813919-0.9923086-0.9813919H6.6017003c-0.5602808,0-1.0217872,0.4621506-1.0087976,1.0222778  c0.4340372,18.7162704,12.7572098,34.9783401,30.5255432,40.4906235c0.2331963,0.0723419,0.3798218,0.3006287,0.3445396,0.5422211  l-0.5018272,3.436142c-0.0556259,0.3808746,0.3219337,0.6791306,0.6795845,0.5368423l11.6039581-4.6165848  c0.3576088-0.1422729,0.4271278-0.6183014,0.125145-0.8569031l-9.7989807-7.7423477  c-0.302021-0.2386322-0.7491035-0.0608139-0.8047295,0.3200607l-0.4584579,3.1391296  C37.2624664,87.5317307,36.9441872,87.7295227,36.6476746,87.6296921z"
      fill="white"
    />
    <path
      d="M63.5370102,6.9942732l0.5018311-3.4362233c0.0556259-0.3808744-0.3219337-0.6791265-0.6795807-0.5368371  L51.7552986,7.6377974c-0.3576088,0.1422729-0.4271278,0.6182985-0.125145,0.8569012l9.7989845,7.7423506  c0.3020172,0.2386303,0.7491035,0.060812,0.8047295-0.3200617l0.4584503-3.1390696  c0.0452156-0.3095846,0.3634987-0.5073767,0.6600075-0.4075403c15.3235168,5.1594534,25.8921661,19.3708344,26.3004456,35.6975479  c0.0136108,0.5442619,0.4478836,0.9813919,0.9923096,0.9813919h2.7532196c0.5602798,0,1.0217896-0.4621506,1.0087967-1.0222778  C93.9730453,29.311245,81.6498642,13.0496321,63.8815269,7.5364904C63.6483459,7.4641385,63.5017281,7.2358603,63.5370102,6.9942732  z"
      fill="white"
    />
    <path
      d="M31.0877228,9.6690865L9.6687994,31.0880108c-2.9510636,2.9510632-2.9510636,7.7523251,0,10.7033901l48.5400848,48.5400887  c2.950737,2.950737,7.7519989,2.950737,10.703064-0.0003281l21.4189224-21.4189224  c2.9513931-2.9513931,2.9513931-7.7526588,0.0006561-10.703392L41.7914429,9.6687584  C38.8403778,6.7176948,34.0391159,6.7176948,31.0877228,9.6690865z M20.5543537,25.0706768  c-0.2732868-0.2732868-0.2733288-0.7182369-0.000042-0.9915237l3.5248814-3.5248814  c0.2734928-0.2734928,0.7182369-0.2732468,0.9915257,0.0000401l0.0823421,0.0823441  c0.2732887,0.2732868,0.2734928,0.7179909,0,0.9914837l-3.5248814,3.5248814c-0.2732868,0.2732868-0.718195,0.2732868-0.9914818,0  L20.5543537,25.0706768z M80.9613037,74.120575l-6.840683,6.8406906c-0.5529327,0.5529327-1.4577255,0.552887-2.0106583-0.0000458  c-0.5529785-0.5529709-0.5529785-1.4577255-0.0000458-2.0106583l6.840683-6.840683  c0.5529404-0.5529327,1.4576874-0.5529327,2.0106659,0.0000381C81.5141983,72.6628494,81.5142365,73.5676422,80.9613037,74.120575z   M87.6802597,57.8367615c0.3712616,0.3712616,0.3712616,0.9731445,0,1.3444061L59.1812096,87.6802139  c-0.3712616,0.3712616-0.9731445,0.3712616-1.3444061,0L10.8273077,40.6707191  c-0.3712215-0.3712196-0.3712626-0.9731407,0-1.3444061L39.326355,10.8272667c0.3712616-0.3712626,0.9731865-0.3712215,1.3444061,0  L87.6802597,57.8367615z"
      fill="white"
    />
  </svg>
))`
  width: 200px;
  animation: ${rotateAnimation} 5s infinite linear;
`;

const RotatePrompt = () => {
  return (
    <Container>
      <RotateIcon />
      <Text>
        Please rotate your device
        <br />
        to portrait mode
        <br />
        and hide mobile keyboard
      </Text>
    </Container>
  );
};

export default RotatePrompt;
